import React, {memo, useEffect} from "react";
import {useHistory, useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTable} from "../../../../property_list/PropertyListTable";
import {Country} from "../../../../region/types/Country";
import {OfferDisplayType} from "../../../helpers/OfferDisplayType";
import {IOfferDetail} from "../../../types/IOfferDetail";
import {ISalesOffice} from "../../../types/ISalesOffice";
import {OfferPriceType} from "../../../types/OfferPriceType";
import {OfferType} from "../../../types/OfferType";
import {PropertyListTabTypes} from "../../actions/fetch_offer_detail_properties";

interface IProps {
    offerId: number;
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmData: {
        listId: string;
        listName: string;
    };
}

export interface IPropertyListOffer {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
        personal_data_processor_name: string | null;
        personal_data_processor_url: string | null;
        privacy_policy_url: string | null;
    };
    is_active?: boolean;
    is_condohotel?: boolean;
    geo_point: {
        coordinates: [number, number];
    };
    has_required_prices: boolean | null;
    id: number;
    is_phone_clip_enabled: boolean;
    name: string;
    stats: {
        properties_with_roi_count: number;
        properties_count_for_sale: number;
        rooms: number[];
    } | null;
    is_holiday_location: boolean;
    price_type: OfferPriceType | null;
    region: {
        country: Country;
        id: number;
        full_name: string;
    };
    sales_offices: ISalesOffice[];
    slug: string;
    type: OfferType;
    vendor: {
        configuration: {
            privacy_policy_url: string | null;
            privacy_policy_file: string | null;
        };
        id: number;
        name: string;
        logo: {
            v_log_80x60: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
        offices: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
}

export const propertyListTableFiltersFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox
    // construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTable: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, onSortChange, sort, tab, page, requestState, properties, pageIsLoading} = props.propertyListObj;
    const location = useLocation();
    const prevLocation = usePrevious(location, location);
    const history = useHistory();
    const {isMobile} = useUserDevice();

    const handlePageChange = async (value: number): Promise<unknown[] | void> => {
        //investments tab does not contain filter so to avoid their propagation query next page without filter params
        const filterQueryValues = tab.currentTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, props.filterValues) : {};
        return await onPageChange(value, filterQueryValues);
    };

    const handleSortChange = (value: string) => {
        const filterQueryValues = toQueryValues(propertyListTableFiltersFields, props.filterValues);
        onSortChange(value, filterQueryValues);
    };

    useEffect(() => {
        if (!prevLocation.hash && location.hash === "#nieruchomosci") {
            history.replace(location.pathname + location.search);
            tab.setCurrentTab(PropertyListTabTypes.INVESTMENT);
        }
    }, [location]);

    return (
        <>
            {props.offer && (
                <PropertyListTable
                    requestState={requestState}
                    offer={props.offer}
                    properties={properties}
                    sort={sort.currentSort}
                    onSortChange={handleSortChange}
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    pageIsLoading={pageIsLoading}
                    currentPage={page.currentPage}
                    gtmMeta={{
                        listId: props.gtmData.listId,
                        listName: props.gtmData.listName
                    }}
                />
            )}

            {pageCount > 0 && (
                <Pagination
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});
import React, {memo, useEffect} from "react";
import {useHistory, useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTable} from "../../../../property_list/PropertyListTable";
import {Country} from "../../../../region/types/Country";
import {OfferDisplayType} from "../../../helpers/OfferDisplayType";
import {IOfferDetail} from "../../../types/IOfferDetail";
import {ISalesOffice} from "../../../types/ISalesOffice";
import {OfferPriceType} from "../../../types/OfferPriceType";
import {OfferType} from "../../../types/OfferType";
import {PropertyListTabTypes} from "../../actions/fetch_offer_detail_properties";

interface IProps {
    offerId: number;
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmData: {
        listId: string;
        listName: string;
    };
}

export interface IPropertyListOffer {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
        personal_data_processor_name: string | null;
        personal_data_processor_url: string | null;
        privacy_policy_url: string | null;
    };
    is_active?: boolean;
    is_condohotel?: boolean;
    geo_point: {
        coordinates: [number, number];
    };
    has_required_prices: boolean | null;
    id: number;
    is_phone_clip_enabled: boolean;
    name: string;
    stats: {
        properties_with_roi_count: number;
        properties_count_for_sale: number;
        rooms: number[];
    } | null;
    is_holiday_location: boolean;
    price_type: OfferPriceType | null;
    region: {
        country: Country;
        id: number;
        full_name: string;
    };
    sales_offices: ISalesOffice[];
    slug: string;
    type: OfferType;
    vendor: {
        configuration: {
            privacy_policy_url: string | null;
            privacy_policy_file: string | null;
        };
        id: number;
        name: string;
        logo: {
            v_log_80x60: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
        offices: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
}

export const propertyListTableFiltersFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox
    // construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTable: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, onSortChange, sort, tab, page, requestState, properties, pageIsLoading} = props.propertyListObj;
    const location = useLocation();
    const prevLocation = usePrevious(location, location);
    const history = useHistory();
    const {isMobile} = useUserDevice();

    const handlePageChange = async (value: number): Promise<unknown[] | void> => {
        //investments tab does not contain filter so to avoid their propagation query next page without filter params
        const filterQueryValues = tab.currentTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, props.filterValues) : {};
        return await onPageChange(value, filterQueryValues);
    };

    const handleSortChange = (value: string) => {
        const filterQueryValues = toQueryValues(propertyListTableFiltersFields, props.filterValues);
        onSortChange(value, filterQueryValues);
    };

    useEffect(() => {
        if (!prevLocation.hash && location.hash === "#nieruchomosci") {
            history.replace(location.pathname + location.search);
            tab.setCurrentTab(PropertyListTabTypes.INVESTMENT);
        }
    }, [location]);

    return (
        <>
            {props.offer && (
                <PropertyListTable
                    requestState={requestState}
                    offer={props.offer}
                    properties={properties}
                    sort={sort.currentSort}
                    onSortChange={handleSortChange}
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    pageIsLoading={pageIsLoading}
                    currentPage={page.currentPage}
                    gtmMeta={{
                        listId: props.gtmData.listId,
                        listName: props.gtmData.listName
                    }}
                />
            )}

            {pageCount > 0 && (
                <Pagination
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});
